import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { getCoafGroupLabel } from '../../services/complianceTranslations';

export default function RulesGroupAccordion({ group, rules = [], onEditGroup, canManage = true }) {
  const activeCount = rules.filter((r) => r.active).length;
  const editableCount = rules.filter((r) => r.canEditThresholds).length;

  return (
    <Accordion variant="outlined">
      <AccordionSummary>
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          sx={{ width: '100%', flexWrap: 'wrap', py: 0.5 }}
        >
          <Typography variant="subtitle1" sx={{ fontWeight: 600, flex: 1 }}>
            {getCoafGroupLabel(group)}
          </Typography>
          <Chip size="small" label={`${rules.length} regras`} />
          <Chip size="small" color="success" variant="outlined" label={`${activeCount} ativas`} />
          {editableCount > 0 ? (
            <Chip size="small" color="info" variant="outlined" label={`${editableCount} com limiares`} />
          ) : null}
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        <Stack spacing={2}>
          <TableContainer>
            <Table size="small" aria-label={`regras do grupo ${group}`}>
              <TableHead>
                <TableRow>
                  <TableCell>Código</TableCell>
                  <TableCell>Título</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Restrição</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rules.map((rule) => (
                  <TableRow key={rule.id} hover>
                    <TableCell>{rule.code}</TableCell>
                    <TableCell>{rule.title}</TableCell>
                    <TableCell>
                      <Chip
                        size="small"
                        label={rule.active ? 'Ativa' : 'Inativa'}
                        color={rule.active ? 'success' : 'default'}
                        variant="outlined"
                      />
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                        {rule.blockedReason || '-'}
                      </Typography>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          {canManage ? (
            <Box>
              <Button
                variant="contained"
                color="secondary"
                size="small"
                disableRipple
                onClick={() => onEditGroup?.(group)}
              >
                Editar regras — {getCoafGroupLabel(group)}
              </Button>
            </Box>
          ) : null}
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
}
